import { withRouter } from 'react-router-dom';
import React, {
    useCallback
} from 'react';
import PropTypes from 'prop-types';
import { useValidation } from 'gw-portals-validation-react';
import { useDataRefresh, ViewModelForm } from 'gw-portals-viewmodel-react';
import { useModal } from '@jutro/components';
import { ServiceReportPopup, SearchServiceOrClaimPopup } from 'gw-capability-servicerequest-react';
import metadata from './ServiceRequestListSearchPanelComponent_AX.metadata.json5';
import messages from './ServiceRequestListSearchPanelComponent_AX.messages';

function ServiceRequestListSearchPanelComponentAX(props) {
    const {
        searchDTO,
        onModelChanged,
        onPrintReport,
        servicesList,
        allItems,
        authHeader,
        receiveItemsFromPopup,
        history
    } = props;

    const { isComponentValid, onValidate } = useValidation('componentContent');
    const { refreshData } = useDataRefresh();
    const { showModal } = useModal();

    const handleModelChanged = useCallback((actualModel) => {
        onModelChanged(actualModel);
        refreshData();
    }, [searchDTO, refreshData]);

    const showServiceReportPopup = useCallback(() => {
        showModal(
            <ServiceReportPopup
                onPrintReport={onPrintReport}
                allItems={allItems}
                authHeader={authHeader}
            />
        );
    }, []);

    const showSearchServiceOrClaimPopup = useCallback(() => {
        showModal(
            <SearchServiceOrClaimPopup
                authHeader={authHeader}
                updateResults={receiveItemsFromPopup}
                allItems={allItems}
                history={history}
            />
        );
    }, []);

    const overrides = {
        serviceTypeSearchDropdown: {
            availableValues: servicesList
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate: onValidate,
            showServiceReportPopup: showServiceReportPopup,
            showSearchServiceOrClaimPopup: showSearchServiceOrClaimPopup,
        }
    };
    return (
        <>
            <ViewModelForm
                uiProps={metadata.componentContent.content}
                model={searchDTO}
                onValidationChange={onValidate}
                onModelChange={handleModelChanged}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
            />
        </>
    );
}

ServiceRequestListSearchPanelComponentAX.propTypes = {
    searchDTO: PropTypes.object.isRequired,
    onModelChanged: PropTypes.func.isRequired,
    onPrintReport: PropTypes.func.isRequired,
    servicesList: PropTypes.array.isRequired,
    allItems: PropTypes.array.isRequired,
    authHeader: PropTypes.object,
    receiveItemsFromPopup: PropTypes.func.isRequired,
};

export default withRouter(ServiceRequestListSearchPanelComponentAX);
